import axios from 'axios'
import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const feedService = {
  getNewsFeed,
  postNewFeed,
  addReactionToMessage,
  deleteReactionFromMessage,
  editFeed,
  deleteFeed,
  deleteFileFromFeed,
  saveDraftNewsFeed,
  unpinMessageFromTop,
  pinMessageToTop,
  getFeedBlock,
  locatePostInNewsFeed,
  getGeneralFeedCTAs,
  createBackgroundTag,
  getSharingTagFiles
}

let cancel

function getNewsFeed(type, objectId, offset, quantity, workplaceIds, scope = '') {
  const params = {
    type,
    object_id: objectId
  }
  if (type === 'organization') {
    params.workplace_ids = workplaceIds
  }
  if (offset) {
    params.content_offset = offset
  }
  if (quantity) {
    params.content_quantity = quantity
  }
  if (scope) {
    params.scope = scope
  }

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
//   return doRequestAxios(`/v2/newsfeed/information`, requestOptions)
  return doRequestAxios(`/newsfeed/feed/open`, requestOptions)
}

function postNewFeed(
  newsfeedId,
  message,
  originMessageId,
  fileIds,
  taggedUserIds,
  containedLinks,
  quantity,
  organizationId,
  workplaceIds
) {
  const formData = new FormData()
  if (message) {
    formData.append('message', message)
  }
  if (originMessageId) {
    formData.append('origin_message_id', originMessageId)
  }
  if (fileIds) {
    formData.append('file_ids', fileIds)
  }
  if (taggedUserIds) {
    formData.append('tagged_user_ids', taggedUserIds)
  }
  if (containedLinks) {
    formData.append('contained_links', containedLinks)
  }
  if (quantity) {
    formData.append('content_quantity', quantity)
  }
  if (organizationId) {
    formData.append('organization_id', organizationId)
  }
  if (workplaceIds && workplaceIds.length >= 1) {
    formData.append('workplace_ids', workplaceIds)
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(1, ''),
    params: formData
  }
//   return doRequestAxios(`/v2/newsfeed/message/add?newsfeed_id=${newsfeedId}`, requestOptions)
  return doRequestAxios(`/newsfeed/message/add?newsfeed_id=${newsfeedId}`, requestOptions)
}

function addReactionToMessage(messageId, unicode, quantity, organizationId, workplaceIds) {
  let params = quantity ? `?content_quantity=${quantity}` : ''
  params += organizationId ? `&organization_id=${organizationId}` : ''
  params += workplaceIds && workplaceIds.length >= 1 ? `&workplace_ids=${workplaceIds}` : ''
  const data = { message_id: messageId, unified_unicode: unicode }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: data
  }

//   return doRequestAxios(`/v2/newsfeed/message/reaction/add${params}`, requestOptions)
  return doRequestAxios(`/newsfeed/reaction/add${params}`, requestOptions)
}
function deleteReactionFromMessage(reactionId, quantity, organizationId, workplaceIds) {
  let params = quantity ? `&content_quantity=${quantity}` : ''
  params += organizationId ? `&organization_id=${organizationId}` : ''
  params += workplaceIds && workplaceIds.length >= 1 ? `&workplace_ids=${workplaceIds}` : ''
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

//   return doRequestAxios(`/v2/newsfeed/message/reaction/delete?reaction_id=${reactionId}${params}`, requestOptions)
  return doRequestAxios(`/newsfeed/reaction/delete?reaction_id=${reactionId}${params}`, requestOptions)
}

function deleteFeed(messageId, quantity, organizationId, workplaceIds) {
  let params = quantity ? `&content_quantity=${quantity}` : ''
  params += organizationId ? `&organization_id=${organizationId}` : ''
  params += workplaceIds && workplaceIds.length >= 1 ? `&workplace_ids=${workplaceIds}` : ''
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
//   console.log(`URL:: /v2/newsfeed/message/delete?message_id=${messageId}${params}`)
//   return doRequestAxios(`/v2/newsfeed/message/delete?message_id=${messageId}${params}`, requestOptions)
  return doRequestAxios(`/newsfeed/message/delete?message_id=${messageId}${params}`, requestOptions)
}

function editFeed(messageId, message, taggedUserIds, containedLinks, quantity, organizationId, workplaceIds) {
  const params = { message: message }
  if (quantity) {
    params.content_quantity = quantity
  }
  if (organizationId) {
    params.organization_id = organizationId
  }
  if (workplaceIds && workplaceIds.length >= 1) {
    params.workplace_ids = workplaceIds
  }
  if (taggedUserIds) {
    params.tagged_user_ids = taggedUserIds
  }
  if (containedLinks) {
    params.contained_links = containedLinks
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
//   return doRequestAxios(`/v2/newsfeed/message/update?message_id=${messageId}`, requestOptions)
  return doRequestAxios(`/newsfeed/message/update?message_id=${messageId}`, requestOptions)
}

function deleteFileFromFeed(messageId, fileIds, quantity, organizationId, workplaceIds) {
  let params = quantity ? `&content_quantity=${quantity}` : ''
  params += organizationId ? `&organization_id=${organizationId}` : ''
  params += workplaceIds && workplaceIds.length >= 1 ? `&workplace_ids=${workplaceIds}` : ''
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
// API V2025 => /v2/newsfeed/message/delete-file should not be used anymore
  return doRequestAxios(
    `/v2/newsfeed/message/delete-file?message_id=${messageId}&file_ids=${fileIds}${params}`,
    requestOptions
  )
}

function saveDraftNewsFeed(newsfeed_id, origin_message_id, message, file_ids) {
  if (cancel !== undefined) {
    cancel()
  }

  let payload = new FormData()
  if (newsfeed_id) {
    payload.append('newsfeed_id', newsfeed_id)
  }
  if (origin_message_id) {
    payload.append('origin_message_id', origin_message_id)
  }
  if (message) {
    payload.append('message', message)
  }
  if (file_ids) {
    payload.append('file_ids', file_ids)
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c)),
    params: payload
  }
//   return doRequestAxios(`/v2/newsfeed/message/add-draft`, requestOptions)
  return doRequestAxios(`/newsfeed/draft/add`, requestOptions)
}

function pinMessageToTop(messageId, quantity) {
  let params = quantity ? `&content_quantity=${quantity}` : ''
  const requestOptions = {
//     method: 'PUT',
    method: 'POST',
    headers: authHeader(),
    params: null
  }
//   return doRequestAxios(`/v2/newsfeed/message/pin?message_id=${messageId}${params}`, requestOptions)
  return doRequestAxios(`/newsfeed/message/pin?message_id=${messageId}${params}`, requestOptions)
}

function unpinMessageFromTop(messageId, quantity) {
  let params = quantity ? `&content_quantity=${quantity}` : ''
  const requestOptions = {
//     method: 'PUT',
    method: 'DELETE',
    headers: authHeader(),
    params: null
  }
//   return doRequestAxios(`/v2/newsfeed/message/unpin?message_id=${messageId}${params}`, requestOptions)
  return doRequestAxios(`/newsfeed/message/unpin?message_id=${messageId}${params}`, requestOptions)
}

function getFeedBlock(feedId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
//   return doRequestAxios(`/v2/newsfeed/get-feed-block?feed_id=${feedId}`, requestOptions)
  return doRequestAxios(`/newsfeed/feed/block?feed_id=${feedId}`, requestOptions)
}

function locatePostInNewsFeed(post_id, newsfeed_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { post_id, newsfeed_id }
  }
//   return doRequestAxios(`/v2/newsfeed/locatePost`, requestOptions)
  return doRequestAxios(`/newsfeed/message/locate`, requestOptions)
}

function getGeneralFeedCTAs(organizationId, workplaceIds, scope, newMemberOffset, newMemberQuantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      organization_id: organizationId,
      workplace_ids: workplaceIds,
      scope,
      new_members_offset: newMemberOffset,
      new_members_quantity: newMemberQuantity
    }
  }
//   return doRequestAxios(`/v2/newsfeed/general-feed-cta`, requestOptions)
  return doRequestAxios(`/newsfeed/general-feed/cta`, requestOptions)
}

function createBackgroundTag(
  newsfeed_id,
  images_count,
  documents_count,
  origin_message_id,
  message,
  tagged_user_ids,
  tagged_group_ids,
  tagged_mixr_ids,
  contained_links
) {
  const params = {
    newsfeed_id,
    images_count,
    documents_count,
    message,
    tagged_user_ids,
    tagged_group_ids,
    tagged_mixr_ids,
    contained_links
  }
  if (origin_message_id > 0) {
    params.origin_message_id = origin_message_id
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: params
  }
//   return doRequestAxios(`/v2/newsfeed/message/background-tag/create`, requestOptions)
  return doRequestAxios(`/newsfeed/background-tag/create`, requestOptions)
}

function getSharingTagFiles(tag) {
  const params = { tag }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: params
  }
//   return doRequestAxios(`/v2/newsfeed/sharing-tag/get-files`, requestOptions)
  return doRequestAxios(`/newsfeed/sharing-tag/files`, requestOptions)
}
